<template>
  <div>
    <div class="mt-4">
      <v-card-title v-if="canList">
        Filtros
        <v-spacer></v-spacer>
        <v-text-field 
          v-model="search" 
          append-icon="mdi-magnify" 
          label="Pesquisa" 
          single-line 
          hide-details
          class="mr-4"
        ></v-text-field>
        <v-btn color="primary" @click="dialog_indicadores = true">
          Indicadores
        </v-btn>
      </v-card-title>

      <v-data-table 
        :headers="headersComputed" 
        :items="items" 
        :search="search" 
        :loading="loading"
        loading-text="Carregando webhooks..."
        item-key="public_id" 
        class="border" 
        :items-per-page="15">

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Webhooks registrados</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-icon v-if="canList" medium @click="handleGetWebhooks" title="Atualizar">mdi-refresh</v-icon>
            <v-spacer></v-spacer>
            <v-btn v-if="canCreate" color="primary" dark class="mr-2 mb-2" @click="novoWebhook">
              Novo Webhook
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex align-center">
            <v-btn v-if="canList" icon small title="Visualizar" @click="showItem(item)" class="mr-1">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>

            <v-btn v-if="canUpdate" icon small title="Editar" @click="editItem(item)" class="mr-1">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>

            <v-btn v-if="canDelete" icon small title="Excluir" @click="confirmDelete(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.active`]="{ item }">
          <v-chip :color="item.active ? 'success' : 'error'" text-color="white" small>
            {{ item.active ? 'Ativo' : 'Inativo' }}
          </v-chip>
        </template>

        <template v-slot:[`item.http_Method`]="{ item }">
          <v-chip :color="getMethodColor(item.http_Method)" text-color="white" small>
            {{ item.http_Method }}
          </v-chip>
        </template>

        <template v-slot:[`item.type`]="{ item }">
          <v-chip :color="item.type === 'AUTH' ? 'info' : 'warning'" text-color="white" small>
            {{ item.type }}
          </v-chip>
        </template>

        <template v-slot:[`item.gatilho_saida`]="{ item }">
          <v-icon :color="item.gatilho_saida ? 'success' : 'grey'">
            {{ item.gatilho_saida ? 'mdi-check-circle' : 'mdi-close-circle' }}
          </v-icon>
        </template>

        <template v-slot:[`item.gate_detail.trade_name`]="{ item }">
          {{ item.gate_detail ? item.gate_detail.trade_name : '-' }}
        </template>

        <template v-slot:[`item.proprietario_detail.trade_name`]="{ item }">
          {{ item.proprietario_detail ? item.proprietario_detail.trade_name : '-' }}
        </template>

        <template v-slot:[`item.fornecedor_detail.trade_name`]="{ item }">
          {{ item.fornecedor_detail ? item.fornecedor_detail.trade_name : '-' }}
        </template>

        <template v-slot:[`item.terminal_detail.trade_name`]="{ item }">
          {{ item.terminal_detail ? item.terminal_detail.trade_name : '-' }}
        </template>

        <template v-slot:[`item.created_by_detail.user.name`]="{ item }">
          {{ item.created_by_detail && item.created_by_detail.user ? item.created_by_detail.user.name : '-' }}
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          {{
            item.created_at | toBrazilianDateTime
          }}
        </template>

        <template v-slot:[`item.updated_at`]="{ item }">
          {{
            item.updated_at | toBrazilianDateTime
          }}
        </template>
        <template #no-data>
          <v-btn v-if="canList" color="primary" @click="handleGetWebhooks">Reset</v-btn>
          <div v-if="!canList">
            <span class="red--text">Você não tem permissão para visualizar as informações desta
              tela</span>
          </div>
        </template>
      </v-data-table>
    </div>

    <!-- Dialog de Filtros -->
    <v-dialog v-model="dialog_indicadores" max-width="500px">
      <WebhookFilters :headers="headers" @close="close_indicadores" />
    </v-dialog>

    <!-- Dialog de Confirmação para Excluir -->
    <DeleteDialog
      v-model="deleteDialog"
      :item="itemToDelete"
      @confirm="deleteItem"
      @cancel="cancelDelete"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { BasicPermissions, Sequences } from '@/utils/permissions'
import { toBrazilianDateTime } from '@/mixins/convertion'
import WebhookApi from '@/services/webhook/webhook.service'
import WebhookFilters from '@/components/gerencial/webhook/list/Filters'
import DeleteDialog from '@/components/gerencial/webhook/shared/DeleteDialog'
import { WEBHOOKS, setIndicadores } from '@/utils/storages'
const LOCAL_STORAGE_ID = WEBHOOKS

export default {
  name: 'WebhookList',
  components: { 
    WebhookFilters,
    DeleteDialog 
  },
  filters: { toBrazilianDateTime },
  data() {
    return {
      search: '',
      webhookData: {},
      options: {},
      pageSize: 10,
      dialog_indicadores: false,
      deleteDialog: false,
      itemToDelete: null,
      deletingItem: false,
      loading: false,
      headers: [
        { text: 'Nome', align: 'start', value: 'nome', habilited: true, block: false },
        { text: 'Descrição', value: 'descricao', habilited: false, block: false },
        { text: 'URL', value: 'url', habilited: true, block: false },
        { text: 'Método', value: 'http_Method', habilited: true, block: false },
        { text: 'Tipo', value: 'type', habilited: true, block: false },
        { text: 'Tipo Request', value: 'type_request', habilited: false, block: false },
        { text: 'Status', value: 'active', habilited: true, block: false },
        { text: 'Gatilho Saída', value: 'gatilho_saida', habilited: false, block: false },
        { text: 'Gate', value: 'gate_detail.trade_name', habilited: false, block: false },
        { text: 'Proprietário', value: 'proprietario_detail.trade_name', habilited: false, block: false },
        { text: 'Fornecedor', value: 'fornecedor_detail.trade_name', habilited: false, block: false },
        { text: 'Terminal', value: 'terminal_detail.trade_name', habilited: false, block: false },
        { text: 'Criado Por', value: 'created_by_detail.user.name', habilited: false, block: false },
        { text: 'Criado em', value: 'created_at', habilited: true, block: false },
        { text: 'Atualizado em', value: 'updated_at', habilited: false, block: false },
        { text: 'Ações', value: 'actions', habilited: true, block: true, sortable: false },
      ],
    }
  },
  computed: {
    ...mapState('auth', ['empresaAtual']),

    ...mapState('params', [WEBHOOKS.storage]),
    params() {
      return this[WEBHOOKS.storage] || {}
    },
    permission() {
      return Sequences.Webhooks.toString()
    },

    canList() {
      return this.$canDo(BasicPermissions.VISUALIZAR, this.permission)
    },
    canCreate() {
      return this.$canDo(BasicPermissions.CADASTRAR, this.permission)
    },
    canUpdate() {
      return this.$canDo(BasicPermissions.EDITAR, this.permission)
    },
    canDelete() {
      return this.$canDo(BasicPermissions.EXCLUIR, this.permission)
    },

    items() {
      return 'results' in this.webhookData ? this.webhookData.results : []
    },

    headersComputed() {
      return this.headers
        .filter((item) => item.display !== false)
        .filter((header) => !!header.habilited)
    },
  },

  async created() {
    this.headers = setIndicadores(LOCAL_STORAGE_ID, this.headers)
    if (this.canList) {
      await this.handleGetWebhooks()
    }
  },

  methods: {
    ...mapActions('template', [
      'successMessage',
      'errorMessage',
      'setDialogMessage',
    ]),
    close_indicadores() {
      this.dialog_indicadores = false
    },
    async showItem(item) {
      this.$emit('showWebhook', item)
    },
    novoWebhook() {
      this.$emit('newWebhook')
    },
    async handleGetWebhooks() {
      this.loading = true
      try {
        const colaboradorId = this.empresaAtual?.colaborador_id
        if (!colaboradorId) {
          this.errorMessage('Colaborador não identificado.')
          return
        }

        const response = await WebhookApi.getAll(colaboradorId, this.params)

        // Processar a resposta corretamente
        if (response.data) {
          this.webhookData = response
        } else if (response.data && Array.isArray(response.data)) {
          this.webhookData = { results: response.data, count: response.data.length }
        } else if (Array.isArray(response)) {
          this.webhookData = { results: response, count: response.length }
        } else {
          this.webhookData = { results: [], count: 0 }
        }
      } catch (error) {
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          this.errorMessage('Usuário não autorizado.')
        } else {
          this.errorMessage('Ocorreu algum erro inesperado.')
        }
      } finally {
        this.loading = false
      }
    },
    getMethodColor(method) {
      const colors = {
        'GET': 'success',
        'POST': 'info',
        'PUT': 'warning',
        'PATCH': 'orange',
        'DELETE': 'error'
      }
      return colors[method] || 'grey'
    },

    editItem(item) {
      this.$emit('editWebhook', item)
    },

    confirmDelete(item) {
      this.itemToDelete = item
      this.deleteDialog = true
    },

    cancelDelete() {
      this.deleteDialog = false
      this.itemToDelete = null
      this.deletingItem = false
    },

    async deleteItem() {
      if (!this.itemToDelete) return

      this.deletingItem = true
      try {
        const colaboradorId = this.empresaAtual?.colaborador_id
        if (!colaboradorId) {
          this.errorMessage('Colaborador não identificado.')
          return
        }

        await WebhookApi.delete(colaboradorId, this.itemToDelete.public_id)
        this.successMessage('Webhook desativado com sucesso!')
        this.cancelDelete()
        await this.handleGetWebhooks()
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.errorMessage('Webhook não encontrado.')
        } else if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          this.errorMessage('Você não tem permissão para desativar este webhook.')
        } else {
          this.errorMessage('Erro ao desativar webhook. Tente novamente.')
        }
      } finally {
        this.deletingItem = false
      }
    }
  },
}
</script>